/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {TabModel} from '../../../../../../models'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useGuests} from '../../../../hooks/useGuests'
import {GuestModel} from '../../../guests/model'
import {paginationGuestsService} from '../../../guests/services'

const TableGuestList: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useHoteleria()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const {getCompanies, getClients, getSites, getCamps, getDocumentTypesByCode} =
    useCentralServices()
  const {getTypeStayGuest, getTypeGuest} = useGuests()

  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSites] = useState<SelectOption[]>([])
  const [camp, setCamps] = useState<SelectOption[]>([])
  const [guestStatus, setGuestStatus] = useState<SelectOption[]>([])
  const [documentTypes, setDocumentTypes] = useState<SelectOption[]>([])
  const [typeStayGuest, setTypeStayGuest] = useState<SelectOption[]>([])

  useEffect(() => {
    getCompaniesFn()
    getDocumentTypesFn()
    getTypeStayGuestFn()
    gestGuestStatusFn()
    return () => {
      clearSearchValues()
    }
  }, [])

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    setSites(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    setCamps(data)
  }

  const getDocumentTypesFn = async () => {
    const data = await getDocumentTypesByCode()
    const filterData = data.filter(
      (item) => item.value !== '12' && item.value !== '11' && item.value !== '06',
    )
    setDocumentTypes(filterData)
  }

  const gestGuestStatusFn = async () => {
    const data = await getTypeGuest()
    setGuestStatus(data)
  }

  const getTypeStayGuestFn = async () => {
    const data = await getTypeStayGuest()
    setTypeStayGuest(data)
  }

  const handlePaginationGuests = async () => {
    try {
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await paginationGuestsService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEditItem = (item: GuestModel) => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'detail-guest-list',
      },
      idToDelete: '',
      idToEdit: item.Id,
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetById = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const handleFilterClient = (e: any, name: string) => {
    let value = e.value
    getClientsFn(value)
    const {ClienteId, SiteId, CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  const handleFilterSite = (e: any, name: string) => {
    let value = e.value
    getSitesFn(value)
    const {SiteId, CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  const handleFilterCamp = (e: any, name: string) => {
    let value = e.value
    getCampsFn(value)
    const {CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  const columns: Column<GuestModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetById}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={compani}
            onGetValueSelect={handleFilterClient}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
            onGetValueSelect={handleFilterSite}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'SiteId'}
            selecteable
            data={site}
            onGetValueSelect={handleFilterCamp}
          />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name={'CampamentoId'}
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estatus de Huésped'
            name='TipoHuespedId'
            selecteable
            data={guestStatus}
          />
        ),
        accessor: 'TipoHuesped_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Ap. Paterno' name='ApellidoPaterno' searcheable />
        ),
        accessor: 'ApellidoPaterno',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Ap. Materno' name='ApellidoMaterno' searcheable />
        ),
        accessor: 'ApellidoMaterno',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombres' name='Nombres' searcheable />
        ),
        accessor: 'Nombres',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo Doc.'
            name='TipoDocumentoId'
            selecteable
            data={documentTypes}
          />
        ),
        accessor: 'TipoDocumento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Documento' name='NumeroDocumento' searcheable />
        ),
        accessor: 'NumeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Email' name='Email' searcheable />
        ),
        accessor: 'Email',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Teléfono' name='Telefono' searcheable />
        ),
        accessor: 'Telefono',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Huésped'
            name='EmpresaId'
            selecteable
            data={compani}
          />
        ),
        accessor: 'Empresa_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Estadía'
            name='TipoEstadiaId'
            selecteable
            data={typeStayGuest}
          />
        ),
        accessor: 'TipoEstadia_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) =>
          currentTabItem.fromOtherApp ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEditItem(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEditItem(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [compani, client, site, camp, documentTypes, guestStatus, typeStayGuest, selectedOn],
  )

  useEffect(() => {
    handlePaginationGuests()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      handlePaginationGuests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      handlePaginationGuests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    if (currentTabItem.updated) {
      clearSelected()
      handlePaginationGuests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.updated])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        handlePaginationGuests()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        handlePaginationGuests()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClient([])
      setSites([])
      setCamps([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      {currentTabItem.fromOtherApp ? (
        <KTCard shadow className='m-5'>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      ) : (
        isAllowed('LISTAR') && (
          <KTCard shadow className='m-5'>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </KTCard>
        )
      )}
    </>
  )
}

const TableGuestsListWrapper = () => {
  return (
    <KTableProvider>
      <TableGuestList />
    </KTableProvider>
  )
}

export {TableGuestsListWrapper}
